import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article3 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Психологические и трансформационные игры
      </h5>
      <p className={styles.articles__pharagraph}>
        Мир вокруг нас меняется, а вместе с ним меняется и наша жизнь. Помочь
        нам приспособиться к современной жизни призваны современные
        психологические и обучающие технологии, активно внедряемые в Интернет
        среду. Среди таких вариантов помощи в получении ответа на вопрос «Как?»
        виртуальные онлайн метафорические карты и психологические игры занимают
        не последнее место.
      </p>
      <h5 className={styles.articles__header}>
        МАК - метафорические ассоциативные карты
      </h5>
      <p className={styles.articles__pharagraph}>
        <b>МАК (метафорические ассоциативные карты)</b> — это набор карточек,
        применяемых в качестве одного из методов психотерапии и проработки
        конкретных запросов. МАК также принесут пользу и творческим людям, и
        любителям настольных игр, и всем, кто хочет лучше узнать себя. Любые
        изображения и фотографии могут быть использованы в качестве
        метафорических карт. Их основная задача - подстёгивать воображение,
        запускать ассоциации, служить поводом для размышлений.
      </p>
      <p className={styles.articles__pharagraph}>
        МАК-карты – не гадальные и ничего не предсказывают. Они через некие
        ассоциации способствуют выходу всего скрытого в вашем подсознании.
        Подталкивают к разговору с собой, подсказывают мотивы собственного
        поведения.
      </p>
      <p className={styles.articles__pharagraph}>
        Использовать МАК-карты можно в любое время и в любой ситуации. Для этого
        не существует никаких противопоказаний. Вы можете пойти к специалисту и
        попробовать. Но в принципе, вы можете работать с МАК-картами сами или в
        компании с друзьями. Большинство из колод не являются терапевтическими и
        доступны для людей всех возрастов и культур. Карты прекрасно работают и
        онлайн.
      </p>
      <h5 className={styles.articles__header}>
        Профессиональная психологическая консультация
      </h5>
      <p className={styles.articles__pharagraph}>
        <b>Профессиональная психологическая консультация</b> вид межличностного
        взаимодействия психолога и клиента. Это специальным образом
        организованное общение, в ходе которого психолог помогает клиенту
        осознать проблему и поддержать в выборе вариантов решения.
        Психологическая процедура опирается на разные теоретические подходы,
        проводится в разных формах, с применением различных методов и
        технологий.
      </p>
      <h5 className={styles.articles__header}>
        Психологические и трансформационные игры
      </h5>
      <p className={styles.articles__pharagraph}>
        <b>Психологические и трансформационные игры</b> объединяют в себе
        психотерапию, игру и преображение. Все события в игре являются метафорой
        жизненных ситуаций игроков. Этот чисто творческий процесс помогает
        рассмотреть ситуацию с разных сторон, понять мотивы поступков, увидеть
        возможные варианты действий и их последствия.
      </p>
      <p className={styles.articles__pharagraph}>
        Человек через игру не только познает себя и свое внутреннее
        пространство, а получает возможность сначала изменить себя. И начнет
        менять обстоятельства уже личность с новыми свойствами и умениями. В
        результате качественно проведенной игры человек сможет справиться со
        стрессом, поднимет эмоциональный фон, получит заряд энергии,
        скорректирует задачи и примет правильные решения.
      </p>
      <h5 className={styles.articles__header}>Приложение PSYCards, онлайн</h5>
      <p className={styles.articles__pharagraph}>
        На просторах интернет-пространства размещено множество платформ,
        позволяющих работать с метафорическими картами в окне браузера{" "}
        <b>oнлaйн</b>. Наиболее удобным является <b>приложение PSYCards</b>. Оно
        разработано для оказания психологической помощи онлайн в Skype или
        Hangouts и имеет удобное управление разнообразными картинками. На основе
        виртуальной методики ассоциативных карт PSYCards можно проводить
        метафорические расклады, трансформационные игры и презентации с
        использованием колод по своему выбору.
      </p>
    </div>
  );
};
